
import React from 'react';
import { BUSINESS_INFO } from '../constants';
import { Leaf, Target, Users, Shield } from 'lucide-react';

const About: React.FC = () => {
  return (
    <div className="bg-transparent min-h-screen py-20 lg:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16 reveal-up">
            <h1 className="text-4xl md:text-6xl font-bold text-slate-900 mb-6">Our Story</h1>
            <div className="h-2 w-24 bg-teal-600 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 gap-12">
            <div className="bg-white p-8 md:p-16 rounded-[3rem] shadow-2xl border border-slate-50 reveal-up" style={{ animationDelay: '0.2s' }}>
              <p className="text-xl md:text-2xl font-medium text-slate-800 leading-relaxed mb-8">
                Sangeeta Wellness is a lifestyle and wellness-oriented brand based in India, dedicated to mindful living.
              </p>
              
              <div className="space-y-6 text-slate-600 text-lg leading-relaxed">
                <p>
                  We focus on providing products and services that support daily wellness routines and mindful living. Our mission is to operate with integrity, transparency, and customer-first values while maintaining responsible business practices.
                </p>
                <p>
                  At Sangeeta Wellness, we believe that true well-being comes from balance, consistency, and making informed choices about the products we bring into our daily lives. Based in Jabalpur, Madhya Pradesh, we are proud to serve our community with ethics and dedication.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
                {[
                  { icon: Target, title: "Our Mission", desc: "Operate with integrity and transparency." },
                  { icon: Users, title: "Customer First", desc: "Prioritizing your trust and consistency." },
                  { icon: Leaf, title: "Mindful Living", desc: "Supporting daily healthy routines." },
                  { icon: Shield, title: "Ethical Standards", desc: "Responsible business practices always." }
                ].map((item, i) => (
                  <div key={i} className="flex items-start space-x-4 p-4 rounded-2xl hover:bg-slate-50 transition-colors">
                    <div className="bg-teal-50 p-3 rounded-xl text-teal-600">
                      <item.icon className="w-6 h-6" />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900">{item.title}</h4>
                      <p className="text-sm text-slate-500">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-8 rounded-r-3xl mt-16 relative overflow-hidden group">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:scale-110 transition-transform">
                  <Shield className="w-20 h-20 text-amber-500" />
                </div>
                <p className="text-amber-900 font-bold mb-3 flex items-center">
                   Important Health Notice
                </p>
                <p className="text-amber-800 text-sm leading-relaxed relative z-10">
                  We do not provide medical advice, diagnosis, or treatment. Our offerings are intended to complement general wellness routines and should not be considered a substitute for professional medical guidance. Always consult a qualified professional for health concerns.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
